/**
 * Most locations one write may carry. Mirrors the API's bulk cap
 * (`ADMIN_STAFF_BULK_MAX`, `ArrayMaxSize` on every `locationIds` body), so the
 * dialogs stop the operator before the API answers 400.
 */
export const ORGANIZATION_LOCATIONS_MAX = 100;

/** Page size of the organization locations read (the API caps `limit` at 100). */
export const ORGANIZATION_LOCATIONS_PAGE_SIZE = 100;

/** The API rejects a location `search` longer than this. */
export const ORGANIZATION_LOCATIONS_SEARCH_MAX_LENGTH = 100;
